import { useState, useCallback, useEffect, useRef } from 'react'
import { USER_ROLES } from 'config/roles'
import styled from '@emotion/styled'
import DragAndDropCard from './DragAndDropCard'
import { AddButton } from './index'
import { useSelector, useDispatch } from 'react-redux'
import { useCustomer } from 'api'
import { useParams } from 'react-router-dom'
import { useLogActivity } from 'api'
import { setArnFile, setArnImage } from 'slices/arn_files'
import { setFilterFiles, sanitizeLibraryFileById } from 'slices/customerFiles'
import { setCustomer, incrementImageRefreshCounter } from 'slices/customer'
import {
  setPaymentCard,
  addPaymentCard,
  removePaymentCard,
  addPaymentCardFileWithData,
  removePaymentCardFile,
  markPaymentCardFilesAsNewRelation,
  resetPaymentCardFields
} from 'slices/paymentCards'
import { selectTripAir, removeTripFile } from 'slices/tripAirSlice'
import { selectTripSea, removeFileTripSea } from 'slices/tripseaSlice'
import { addMiscDocData } from 'slices/misc_doc'
import { setApiCall, removeApiCall } from 'slices/apiCallCheckSlice'
import {
  getFormatedDateForCRM,
  generateUUID,
  stripServerOwnedCardFields
} from 'utils/helpers'
import {
  isAmexRefundCard,
  getMissingAmexArnPlaceholders,
  isArnSlotFilled,
  ARN_DOC_TYPE
} from 'utils/arn'
import { useArnSlotPaste } from 'hooks/useArnSlotPaste'
import DuplicateImagesModal from 'components/MergePdf/DuplicateImagesModal'
import DisAllowedImagesModal from 'components/MergePdf/DisAllowedImagesModal'
import { setTripAir } from 'slices/tripAirSlice'
import {
  deleteArnFile,
  deleteArnImage,
  deleteArnByIndex,
  setArnDocFileWithData,
  removeArnDocFile,
  addArnDocData
} from 'slices/arn_files'
import {
  deleteGbApplicationFile,
  deleteGbApplicationImage,
  deleteGbApplicationByIndex,
  setGbApplicationDocFileWithData,
  removeGbApplicationDocFile,
  addGbApplicationDocData
} from 'slices/gb_application_files'
import {
  deleteMiscFile,
  deleteMiscImage,
  removeMiscDoc,
  setMiscDocFileWithData,
  removeMiscDocFile
} from 'slices/misc_doc'
import {
  addPassportFileWithData,
  removePassportFile,
  setSavePassportIdFromApiResponse
} from 'slices/passport'
import { addTripSeaFileWithData } from 'slices/tripseaSlice'
import { addTripAirFileWithData } from 'slices/tripAirSlice'
import { removeUploadedDoc } from 'slices/customerFiles'
import { setPaymentCard as setPaymentCardSecureLink } from 'slices/securelinkslice'
import { selectCustomer, updateCustomerField } from 'slices/customer'
import { api } from 'lib/axios'
import { getUserId } from 'lib/auth/tokenStorage'

// Utility function to extract file ID from file object
const extractFileId = file => {
  if (file?.file_obj?.id) {
    return file.file_obj.id
  } else {
    return file.id
  }
}

// Utility function to process files array and extract IDs
const processFilesArray = (files, additionalFile = null) => {
  const files_arr = []

  // Process existing files from array
  for (let file of files || []) {
    const id = extractFileId(file)
    files_arr.push(id)
  }

  // Process additional file if provided
  if (additionalFile) {
    const id = extractFileId(additionalFile)
    files_arr.push(id)
  }

  return files_arr
}

// Utility function to process files and create object with type keys
const processFilesWithTypes = filesByType => {
  const files_arr = {}
  let counter = 0
  Object.entries(filesByType).forEach(([type, files]) => {
    for (let file of files || []) {
      const id = extractFileId(file)

      if (id) {
        files_arr[counter] = { [type]: id }
        counter += 1
      }
    }
  })

  return files_arr
}

const TravelDocuments = () => {
  const tripAir = useSelector(selectTripAir)
  const tripSea = useSelector(selectTripSea)
  const activeTripType =
    tripAir?.attributes?.air_sea_type || tripSea?.air_sea_type
  const [allPCVerified, setAllPCVerified] = useState(false)
  const [state, setState] = useState({
    cardverificationcount: 0,
    allPurchaseCardVerified: false
  })
  const [loadingStates, setLoadingStates] = useState({
    addCard: false,
    itinerary: false,
    misc: false,
    arn: false,
    gbApplication: false
  })
  const [deleteLoader, setDeleteLoader] = useState({ loading: false, id: '' })
  const statusChangeRef = useRef(false)
  const hasInitializedStatusCheckRef = useRef(false)

  const dispatch = useDispatch()
  const { id: contactId } = useParams()
  const customer = useSelector(state => state?.customer)
  const files = useSelector(state => state?.customer_files?.files)
  const passport = useSelector(state => state?.passport)
  const purchase_cards = useSelector(state => state?.paymentCards?.paymentCards)
  const purchase_requests = useSelector(state => state?.purchaseReceipt?.pr)
  const idleTime = useSelector(state => state?.idleTime)
  const arnFiles = useSelector(state =>
    state?.arn_files?.arn?.length > 0 ? state?.arn_files?.arn : []
  )
  const gbApplicationFiles = useSelector(state =>
    state?.gb_application_files?.gb_application?.length > 0
      ? state.gb_application_files.gb_application
      : []
  )
  const misc_documents = useSelector(state => state?.misc_douments?.misc)
  const customer_files = useSelector(state => state?.customer_files)
  const authData = useSelector(state => state?.auth?.data)
  const currentUser = authData?.current_user
  const userRole = currentUser?.affiliate_role?.toLowerCase()
  const isAmexRefund = isAmexRefundCard(purchase_cards)
  const {
    handleCardPaste,
    isPasting,
    duplicateImagesModal,
    duplicateImagesFiles,
    closeDuplicateModal,
    disallowedImagesModal,
    disAllowedFiles,
    closeDisallowedModal
  } = useArnSlotPaste()

  const {
    handleSetIdleTime,
    isSubmitting,
    handleSetPortalTimeLog,
    handleSetCreateModuleRecord,
    handleSaveFieldsVerificationData,
    handleSavePaymentCreditCards,
    handleSaveTripData,
    DeleteCreditCard,
    handleDeleteArnFile,
    handleDeleteTripDocument,
    handleDeleteItinerary,
    handleUpdateMiscDocument,
    handleSavePassport,
    handleDeletePassport,
    handleDeleteCruiseInfo,
    handleDeleteCruiseSchedule,
    handleDeleteBoarding,
    handleDeleteEntryStamp,
    handleRemoveCreditCardDoc,
    handleResetCreditCardFields,
    handleSetStatusChange
  } = useCustomer()
  const { logApiActivity } = useLogActivity()

  const setLoadingState = (buttonType, isLoading) => {
    setLoadingStates(prev => ({
      ...prev,
      [buttonType]: isLoading
    }))
  }

  const addNewPurchaseCard = async () => {
    let index = purchase_cards?.length
    const result = await handleSetCreateModuleRecord({
      method: 'V8/custom/savedata/create-module-record',
      customer_id: contactId,
      module_name: 'gb_payment_credit_cards',
      fields_data: {
        contact_id: contactId
      }
    })
    if (result?.statusText == 'OK' || result?.status === 200) {
      if (result?.data?.customer_id == contactId) {
        dispatch(addPaymentCard())
        dispatch(
          setPaymentCard({
            no: index,
            attributes: { id: result?.data?.record_id }
          })
        )
        dispatch(
          setPaymentCardSecureLink({
            attributes: { id: result?.data?.record_id }
          })
        )
      }
    } else {
      dispatch(removePaymentCard({ no: index }))
    }
  }

  const cardsverificationresult = async aray => {
    if (state.cardverificationcount === 0) {
      let checker = aray.every(v => v === true)
      if (checker == false) {
        await purchaseCardVerify(!state.allPurchaseCardVerified)
        purchase_cards?.map(async (card, index) => {
          await dispatch(
            setPaymentCard({
              no: index,
              attributes: { verified: !state.allPurchaseCardVerified }
            })
          )
        })
        await purchaseCardCheckVerified()
        await savePaymentCreditCard()
      }
    }
  }

  const purchaseCardVerify = async (loader, count) => {
    const timeoutCount = count && count != '' ? count : 100
    let refund = false
    let array_two = []
    purchase_cards?.map((card, index) => {
      let array = []
      for (const key in card.verify) {
        array.push(card.verify[key])
        array_two.push(card.verify[key])
      }
      if (card.attributes.used_card_refund == true) {
        refund = true
      }
      let checker = array.every(v => v === true)

      if (checker === true) {
        dispatch(
          setPaymentCard({
            no: index,
            attributes: { verified: true }
          })
        )
      } else {
        dispatch(
          setPaymentCard({
            no: index,
            attributes: { verified: false }
          })
        )
      }

      setState({
        cardverificationcount: state.cardverificationcount + 1
      })
    })

    let checker_two = array_two.every(v => v === true)
    if (checker_two == true && refund == true) {
      await purchaseCardCheckVerified()
    } else {
      await purchaseCardCheckVerified()
    }

    if (loader && loader === true) {
      await addNewPurchaseCard()
      await purchaseCardCheckVerified()
    } else if (loader && loader === 'verifyAll') {
      setTimeout(async () => {
        let aray = []
        purchase_cards?.map(async card => {
          var api_result = await saveFieldsVerificationData(
            card.attributes.id,
            'gb_payment_credit_card',
            'gb_payment_credit_cards',
            'verified',
            card.attributes.verified == true ? 1 : 0,
            card.verify
          )
          if (api_result === false) {
            setState({
              cardverificationcount: state.cardverificationcount - 1
            })
            aray.push(api_result)
            cardsverificationresult(aray)
          } else {
            setState({
              cardverificationcount: state.cardverificationcount - 1
            })
            aray.push(api_result)
            cardsverificationresult(aray)
          }
        })
      }, timeoutCount)
    } else if (loader && loader === 'nosave') {
      return
    } else {
      setTimeout(async () => {
        await savePaymentCreditCard()
      }, timeoutCount)
    }
  }

  const purchaseCardCheckVerified = async () => {
    let array = []
    let refund = false
    purchase_cards?.map(card => {
      array.push(card.attributes.verified)
      if (card.attributes.used_card_refund == true) {
        refund = true
      }
    })
    let checker = array.every(v => v === true)
    if (checker == true && refund == true) {
      setAllPCVerified(true)
      setState({ allPurchaseCardVerified: true })
      await MainGbFormTimeOutFunc()
    } else {
      setState({ allPurchaseCardVerified: false })
      setAllPCVerified(false)
    }
  }

  const idleTimeSaving = async () => {
    if (idleTime.idle_time_total > 60) {
      const agent_id = getUserId()
      const payload = {
        agent_id: agent_id,
        contact_id: contactId,
        total_idle_time: Math.round(idleTime.idle_time_total),
        section_name: 'total_idle_time'
      }
      var IdleTimeSave = await handleSetIdleTime(payload)
    } else {
      var IdleTimeSave = await handleSetIdleTime(payload)
    }
  }

  const portalTimeLog = async (prev_section, curr_section) => {
    const agent_id = getUserId()
    const payload = {
      previous_section: prev_section,
      current_section: curr_section,
      agent_id: agent_id,
      contact_id: contactId
    }
    await handleSetPortalTimeLog(payload)
  }

  const saveFieldsVerificationData = async (
    p_id,
    p_name,
    mod_name,
    f_name,
    f_value,
    verification_data
  ) => {
    let save_fields_verification_response =
      await handleSaveFieldsVerificationData({
        parent_id: p_id,
        parent_name: p_name,
        module_name: mod_name,
        field_name: f_name,
        field_value: f_value,
        verification: verification_data,
        contact_id: contactId
      })

    if (save_fields_verification_response?.success == true) {
      return true
    } else {
      return false
    }
  }

  const MainGbFormTimeOutFunc = async () => {
    const passportState = passport.verified
    const purchase_cardState = purchase_cards?.some(
      card => card.attributes.verified === true
    )
    const tripAirState = tripAir.attributes.verify.date_of_visit
    const air_boardingState = tripAir.attributes.boarding_verified
    const sea_cruiseState = tripSea.cruise_verified
    let verifiedPurchase = true
    let verifiedPayment = true

    purchase_requests.map((pr, i) => {
      if (pr.attributes.verified !== true && pr.attributes.verified !== '1') {
        verifiedPurchase = false
      }
      pr.payment_methods.map((cards, i) => {
        if (
          cards.attributes.verified !== true &&
          cards.attributes.verified !== '1'
        ) {
          verifiedPayment = false
        }
      })
    })
    if (activeTripType == 'sea') {
      if (
        verifiedPurchase == true &&
        verifiedPayment == true &&
        passportState == true &&
        purchase_cardState == true &&
        sea_cruiseState == true
      ) {
        if (files.length > 0) {
          if (passport.flag !== true) {
            await idleTimeSaving()
            await portalTimeLog('main_form', '')
          }
        }
      } else {
      }
    } else {
      if (
        verifiedPurchase == true &&
        verifiedPayment == true &&
        passportState == true &&
        purchase_cardState == true &&
        tripAirState == true &&
        air_boardingState == true
      ) {
        if (files.length > 0) {
          if (passport.flag !== true) {
            await idleTimeSaving()
            await portalTimeLog('main_form', '')
          }
        }
      }
    }
  }

  const savePaymentCreditCard = async (
    additionalFile = null,
    targetCardIndex = null
  ) => {
    var purchaseCardsCopy = purchase_cards
    var customerCopy = Object.assign({}, customer)

    var apiCallData = []

    purchaseCardsCopy?.map(async (card, card_no) => {
      var data = []
      var attributes = Object.assign({}, card.attributes)

      attributes.contact_id = contactId
      attributes.name =
        customerCopy.first_name + ' | ' + card.attributes.card_number

      if (attributes.expiration_date) {
        attributes.expiration_date = getFormatedDateForCRM(
          attributes.expiration_date
        )
      } else {
        attributes.expiration_date = ''
      }
      const files_arr =
        additionalFile &&
          targetCardIndex !== null &&
          card_no === targetCardIndex
          ? processFilesArray(card.files, additionalFile)
          : processFilesArray(card.files)

      data[0] = { basic: stripServerOwnedCardFields(attributes) }
      data[1] = { ocr: card.ocr }
      data[2] = { verification: card.verify }
      data[3] = { files: files_arr }
      apiCallData.push({ data })
    })
    dispatch(setApiCall({ api_type: 'credit_card_saving', call: true }))
    let payment_credit_cards_response = await handleSavePaymentCreditCards({
      apiCallData: apiCallData,
      contact_id: contactId
    })

    dispatch(removeApiCall({ api_type: 'credit_card_saving' }))
  }

  const saveTrip = async () => {
    if (activeTripType === 'air') {
      await saveAirTrip()
    } else if (activeTripType === 'sea') {
      await saveCruiseTrip()
    }
  }

  const saveAirTrip = async () => {
    var attributes = Object.assign({}, tripAir.attributes)
    attributes.date_of_visit = getFormatedDateForCRM(attributes.date_of_visit)
    attributes.boarding_date_of_departure = getFormatedDateForCRM(
      attributes.boarding_date_of_departure
    )

    delete attributes.ocr
    delete attributes.verify
    delete attributes.itinerary_clicked
    delete attributes?.arn_clicked

    const files_arr = processFilesWithTypes({
      entry_stamp: tripAir.files.entry_stamp,
      boarding_pass: tripAir.files.boarding_pass,
      itinerary: tripAir.files.itinerary,
      arn: tripAir.files.arn,
      giveback_application: tripAir.files.giveback_application
    })

    var trip_id = ''
    if (tripAir.attributes.id) {
      trip_id = tripAir.attributes.id
    } else if (tripSea.id) {
      trip_id = tripSea.id
    }

    var apiCallData = {
      air_sea_type: 'air',
      date_of_visit: attributes.date_of_visit,
      entry_stamp: attributes.entry_stamp,
      boarding_verified: attributes.boarding_verified,
      send_secure_link: attributes.send_secure_link,
      boarding_first_name: attributes.boarding_first_name,
      boarding_last_name: attributes.boarding_last_name,
      boarding_airline_name: attributes.boarding_airline_name,
      boarding_flight_number: attributes.boarding_flight_number,
      boarding_exit_point: attributes.boarding_exit_point,
      boarding_date_of_departure: attributes.boarding_date_of_departure,
      id: trip_id
    }
    dispatch(setApiCall({ api_type: 'tripAir_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: apiCallData,
      ocr: tripAir.attributes.ocr,
      verification: tripAir.attributes.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripAir_saving' }))
  }

  const saveCruiseTrip = async () => {
    var data = Object.assign({}, tripSea)
    data.date_of_visit = getFormatedDateForCRM(data.date_of_visit)
    delete data.files
    delete data.ocr
    delete data.verify

    const files_arr = processFilesWithTypes({
      cruise: tripSea.files.cruise,
      cruise_schedule: tripSea.files.cruise_schedule,
      itinerary: tripSea.files.itinerary,
      arn: tripSea.files.arn,
      giveback_application: tripSea.files.giveback_application
    })

    data.air_sea_type = 'sea'
    if (tripAir.attributes.id) {
      data.id = tripAir.attributes.id
    } else if (tripSea.id) {
      data.id = tripSea.id
    }
    dispatch(setApiCall({ api_type: 'tripSea_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: { ...data },
      ocr: tripSea.ocr,
      verification: tripSea.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripSea_saving' }))
  }

  const saveArnDoc = async ({ type, id = '', idx = null }) => {
    if (type === 'add') {
      dispatch(
        addArnDocData({
          arn: newObj
        })
      )
    } else if (type === 'drop' && idx !== null) {
      await saveTripWithArnFile(id)
    }
  }

  const saveTripWithArnFile = async fileObj => {
    if (activeTripType === 'air') {
      await saveAirTripWithArnFile(fileObj)
    } else if (activeTripType === 'sea') {
      await saveSeaTripWithArnFile(fileObj)
    }
  }

  const saveAirTripWithArnFile = async fileObj => {
    var attributes = Object.assign({}, tripAir.attributes)
    attributes.date_of_visit = getFormatedDateForCRM(attributes.date_of_visit)
    attributes.boarding_date_of_departure = getFormatedDateForCRM(
      attributes.boarding_date_of_departure
    )

    delete attributes.ocr
    delete attributes.verify
    delete attributes.itinerary_clicked
    delete attributes?.arn_clicked

    var files_arr = {}

    const id = extractFileId(fileObj)

    if (id) {
      files_arr[0] = { arn: id }
    }

    var trip_id = ''
    if (tripAir.attributes.id) {
      trip_id = tripAir.attributes.id
    } else if (tripSea.id) {
      trip_id = tripSea.id
    }

    var apiCallData = {
      air_sea_type: tripAir.attributes.air_sea_type,
      date_of_visit: attributes.date_of_visit,
      entry_stamp: attributes.entry_stamp,
      boarding_verified: attributes.boarding_verified,
      send_secure_link: attributes.send_secure_link,
      boarding_first_name: attributes.boarding_first_name,
      boarding_last_name: attributes.boarding_last_name,
      boarding_airline_name: attributes.boarding_airline_name,
      boarding_flight_number: attributes.boarding_flight_number,
      boarding_exit_point: attributes.boarding_exit_point,
      boarding_date_of_departure: attributes.boarding_date_of_departure,
      id: trip_id
    }

    dispatch(setApiCall({ api_type: 'tripAir_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: apiCallData,
      ocr: tripAir.attributes.ocr,
      verification: tripAir.attributes.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripAir_saving' }))
  }

  const saveSeaTripWithArnFile = async fileObj => {
    var data = Object.assign({}, tripSea)
    data.date_of_visit = getFormatedDateForCRM(data.date_of_visit)
    delete data.files
    delete data.ocr
    delete data.verify

    var files_arr = {}

    const id = extractFileId(fileObj)

    if (id) {
      files_arr[0] = { arn: id }
    }

    data.air_sea_type = 'sea'
    if (tripAir.attributes.id) {
      data.id = tripAir.attributes.id
    } else if (tripSea.id) {
      data.id = tripSea.id
    }

    dispatch(setApiCall({ api_type: 'tripSea_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: { ...data },
      ocr: tripSea.ocr,
      verification: tripSea.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripSea_saving' }))
  }

  const saveTripWithGbApplicationFile = async fileObj => {
    if (activeTripType === 'air') {
      await saveAirTripWithGbApplicationFile(fileObj)
    } else if (activeTripType === 'sea') {
      await saveSeaTripWithGbApplicationFile(fileObj)
    }
  }

  const saveAirTripWithGbApplicationFile = async fileObj => {
    var attributes = Object.assign({}, tripAir.attributes)
    attributes.date_of_visit = getFormatedDateForCRM(attributes.date_of_visit)
    attributes.boarding_date_of_departure = getFormatedDateForCRM(
      attributes.boarding_date_of_departure
    )

    delete attributes.ocr
    delete attributes.verify
    delete attributes.itinerary_clicked
    delete attributes?.arn_clicked

    var files_arr = {}

    const id = extractFileId(fileObj)

    if (id) {
      files_arr[0] = { giveback_application: id }
    }

    var trip_id = ''
    if (tripAir.attributes.id) {
      trip_id = tripAir.attributes.id
    } else if (tripSea.id) {
      trip_id = tripSea.id
    }

    var apiCallData = {
      air_sea_type: tripAir.attributes.air_sea_type,
      date_of_visit: attributes.date_of_visit,
      entry_stamp: attributes.entry_stamp,
      boarding_verified: attributes.boarding_verified,
      send_secure_link: attributes.send_secure_link,
      boarding_first_name: attributes.boarding_first_name,
      boarding_last_name: attributes.boarding_last_name,
      boarding_airline_name: attributes.boarding_airline_name,
      boarding_flight_number: attributes.boarding_flight_number,
      boarding_exit_point: attributes.boarding_exit_point,
      boarding_date_of_departure: attributes.boarding_date_of_departure,
      id: trip_id
    }

    dispatch(setApiCall({ api_type: 'tripAir_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: apiCallData,
      ocr: tripAir.attributes.ocr,
      verification: tripAir.attributes.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripAir_saving' }))
  }

  const saveSeaTripWithGbApplicationFile = async fileObj => {
    var data = Object.assign({}, tripSea)
    data.date_of_visit = getFormatedDateForCRM(data.date_of_visit)
    delete data.files
    delete data.ocr
    delete data.verify

    var files_arr = {}

    const id = extractFileId(fileObj)

    if (id) {
      files_arr[0] = { giveback_application: id }
    }

    data.air_sea_type = 'sea'
    if (tripAir.attributes.id) {
      data.id = tripAir.attributes.id
    } else if (tripSea.id) {
      data.id = tripSea.id
    }

    dispatch(setApiCall({ api_type: 'tripSea_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: { ...data },
      ocr: tripSea.ocr,
      verification: tripSea.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripSea_saving' }))
  }

  const handleAddCard = async () => {
    setLoadingState('addCard', true)

    try {
      await purchaseCardVerify(true)
    } finally {
      setLoadingState('addCard', false)
    }
  }

  const handleAddItinerary = async () => {
    setLoadingState('itinerary', true)
    try {
      const hasItineraryWithImages = tripAir?.files?.itinerary?.some(
        file => file && (file?.file_obj?.id || file?.id)
      )

      if (hasItineraryWithImages) {
        dispatch(
          setTripAir({
            itinerary_clicked: true
          })
        )
        await saveTrip()
      } else {
        dispatch(
          setTripAir({
            itinerary_clicked: true
          })
        )
      }
    } finally {
      setLoadingState('itinerary', false)
    }
  }

  const handleAddMisc = () => {
    setLoadingState('misc', true)
    try {
      dispatch(addMiscDocData({ isNew: true }))
    } finally {
      setLoadingState('misc', false)
    }
  }

  const handleAddArn = async () => {
    setLoadingState('arn', true)
    try {
      dispatch(addArnDocData({ isNew: true, gb_doc_type: ARN_DOC_TYPE, files: [] }))
    } finally {
      setLoadingState('arn', false)
    }
  }

  const handleAddGbApplication = async () => {
    setLoadingState('gbApplication', true)
    try {
      dispatch(addGbApplicationDocData({ isNew: true }))
    } finally {
      setLoadingState('gbApplication', false)
    }
  }

  useEffect(() => {
    if (!customer?.id || !isAmexRefund) return
    const placeholders = getMissingAmexArnPlaceholders(arnFiles)
    placeholders.forEach(placeholder => {
      dispatch(addArnDocData(placeholder))
    })
  }, [customer?.id, isAmexRefund, arnFiles.length, dispatch])

  const savePassport = useCallback(
    async (additionalFile = null) => {
      let data = Object.assign({}, passport)
      data.date_of_birth = getFormatedDateForCRM(data.date_of_birth)
      data.date_of_expiry = getFormatedDateForCRM(data.date_of_expiry)
      data.date_of_issue = getFormatedDateForCRM(data.date_of_issue)

      delete data.files
      delete data.ocr
      delete data.verify
      delete data.flag
      const passortId = passport?.id
      if (passortId) {
        data.id = passortId
      }
      const files_arr = processFilesArray(passport.files, additionalFile)
      dispatch(setApiCall({ api_type: 'passport_saving', call: true }))

      let res = await handleSavePassport({
        basic: { ...data },
        ocr: passport.ocr,
        verification: passport.verify,
        files: files_arr,
        contact_id: contactId
      })
      dispatch(setSavePassportIdFromApiResponse(res?.data?.id))
      dispatch(removeApiCall({ api_type: 'passport_saving' }))
    },
    [passport, handleSavePassport, contactId, dispatch]
  )

  const dropPassport = async id => {
    const agentId = getUserId() || ''
    await logApiActivity({
      contactId: contactId,
      agentId,
      apiEndpoint: '/Api/V8/custom/savedata/save-passport',
      actionType: 'drag_drop_passport',
      requestPayload: {
        contact_id: contactId,
        file_id: id?.file_obj?.id || id?.id
      },
      apiCall: async () => {
        dispatch(
          addPassportFileWithData({
            file: { ...id, new_relation_addition: true }
          })
        )
        dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
        await savePassport(id)
      }
    })
  }

  const dropCruiseInfo = async id => {
    const agentId = getUserId() || ''
    await logApiActivity({
      contactId: contactId,
      agentId,
      apiEndpoint: '/Api/V8/custom/savedata/save-trip-data',
      actionType: 'drag_drop_cruise_info',
      requestPayload: {
        contact_id: contactId,
        file_type: 'cruise',
        file_id: id?.file_obj?.id || id?.id
      },
      apiCall: async () => {
        dispatch(
          addTripSeaFileWithData({
            file_type: 'cruise',
            file: { ...id, new_relation_addition: true }
          })
        )
        dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
        await saveSeaTripWithAdditionalFile('cruise', id)
      }
    })
  }

  const dropCruiseSchedule = async id => {
    const agentId = getUserId() || ''
    await logApiActivity({
      contactId: contactId,
      agentId,
      apiEndpoint: '/Api/V8/custom/savedata/save-trip-data',
      actionType: 'drag_drop_cruise_schedule',
      requestPayload: {
        contact_id: contactId,
        file_type: 'cruise_schedule',
        file_id: id?.file_obj?.id || id?.id
      },
      apiCall: async () => {
        dispatch(
          addTripSeaFileWithData({
            file_type: 'cruise_schedule',
            file: { ...id, new_relation_addition: true }
          })
        )
        dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
        await saveSeaTripWithAdditionalFile('cruise_schedule', id)
      }
    })
  }

  const dropBoarding = async id => {
    const agentId = getUserId() || ''
    await logApiActivity({
      contactId: contactId,
      agentId,
      apiEndpoint: '/Api/V8/custom/savedata/save-trip-data',
      actionType: 'drag_drop_boarding_pass',
      requestPayload: {
        contact_id: contactId,
        file_type: 'boarding_pass',
        file_id: id?.file_obj?.id || id?.id
      },
      apiCall: async () => {
        dispatch(
          addTripAirFileWithData({
            file_type: 'boarding_pass',
            file: { ...id, new_relation_addition: true }
          })
        )
        dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
        await saveTripWithAdditionalFile('boarding_pass', id)
      }
    })
  }

  const dropEntryStamp = async id => {
    const agentId = getUserId() || ''
    await logApiActivity({
      contactId: contactId,
      agentId,
      apiEndpoint: '/Api/V8/custom/savedata/save-trip-data',
      actionType: 'drag_drop_entry_stamp',
      requestPayload: {
        contact_id: contactId,
        file_type: 'entry_stamp',
        file_id: id?.file_obj?.id || id?.id
      },
      apiCall: async () => {
        dispatch(
          addTripAirFileWithData({
            file_type: 'entry_stamp',
            file: { ...id, new_relation_addition: true }
          })
        )
        dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
        await saveAirTripWithAdditionalFile('entry_stamp', id)
      }
    })
  }

  const dropCreditCard = async (id, index) => {
    const checkCards =
      purchase_cards && purchase_cards[index]?.files?.length < 3

    if (checkCards) {
      const agentId = getUserId() || ''
      await logApiActivity({
        contactId: contactId,
        agentId,
        apiEndpoint: '/Api/V8/custom/savedata/save-payment-credit-cards',
        actionType: 'drag_drop_credit_card',
        requestPayload: {
          contact_id: contactId,
          card_index: index,
          file_id: id?.file_obj?.id || id?.id
        },
        apiCall: async () => {
          dispatch(
            addPaymentCardFileWithData({
              no: index,
              file: {
                ...id,
                new_relation_addition: true,
                gb_doc_type: 'credit_card_image',
                file_obj: id?.file_obj
                  ? { ...id.file_obj, gb_doc_type: 'credit_card_image' }
                  : id?.file_obj
              }
            })
          )
          dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
          await savePaymentCreditCard(id, index)
        }
      })
    }
  }

  const handleDeleteMiscDocument = async (item, type) => {
    const hasFiles = item?.files && item.files.length > 0
    const hasImage =
      hasFiles && item.files.some(file => file?.file_obj?.id || file?.id)

    if (hasImage) {
      // Get the first file with an actual file object
      const fileWithImage = item.files.find(
        file => file?.file_obj?.id || file?.id
      )

      const fileId = fileWithImage?.file_obj?.id || fileWithImage?.id
      fileWithImage?.id

      setDeleteLoader({ loading: true, id: fileId })

      try {
        await handleUpdate({ file: { ...fileWithImage } }, 'delete')

        // Remove the misc document card from UI
        const itemIndex = misc_documents?.findIndex(doc => doc === item)
        if (itemIndex !== -1) {
          dispatch(removeMiscDocFile({ no: itemIndex }))
        }

        if (type === 'non') {
          dispatch(deleteMiscFile({ id: fileId }))
        } else if (type === 'delete') {
          dispatch(deleteMiscImage({ id: fileId }))
        }

        if (fileWithImage?.file_obj?.id || fileWithImage?.id) {
          dispatch(
            setFilterFiles({
              file: {
                file_no: customer_files?.files?.length,
                file: {},
                id: generateUUID(),
                fileName: fileWithImage?.file_obj?.file_name || '',
                status: 'File uploaded successfully.',
                progress: 100,
                isUploaded: true,
                isError: false,
                file_obj: fileWithImage?.file_obj || fileWithImage
              }
            })
          )
        }
      } catch (error) {
        console.error('Error deleting misc document:', error)
      } finally {
        setDeleteLoader({ loading: false, id: '' })
      }
    } else {
      if (type === 'non') {
        const itemIndex = misc_documents?.findIndex(doc => doc === item)
        if (itemIndex !== -1) {
          dispatch(removeMiscDoc({ no: itemIndex }))
        }
      }
    }
  }

  const handleDeleteArnFileLocal = async (item, type) => {
    const tripId = tripAir?.attributes?.id || tripSea?.id
    const hasFiles = item?.files && item.files.length > 0
    const hasImage =
      hasFiles && item.files.some(file => file?.file_obj?.id || file?.id)

    if (hasImage) {
      // Get the first file with an actual file object
      const fileWithImage = item.files.find(
        file => file?.file_obj?.id || file?.id
      )

      const fileId = fileWithImage?.file_obj?.id || fileWithImage?.id
      fileWithImage?.id
      setDeleteLoader({ loading: true, id: fileId })
      try {
        await handleDeleteArnFile(tripId, fileId)
        await api.patch('/Api/V8/module', {
          data: {
            id: fileId,
            type: 'Documents',
            attributes: {
              gb_doc_type_c: ''
            }
          }
        })

        // Remove the ARN document card from UI
        const itemIndex = arnFiles?.findIndex(doc => doc === item)
        if (itemIndex !== -1) {
          dispatch(removeArnDocFile({ no: itemIndex }))
        }

        // Also remove ARN files from trip files (tripAir and tripSea)
        if (tripAir?.files?.arn) {
          const tripAirArnIndex = tripAir.files.arn.findIndex(
            arnFile =>
              arnFile?.id === fileId || arnFile?.file_obj?.id === fileId
          )
          if (tripAirArnIndex !== -1) {
            dispatch(
              removeTripFile({ file_type: 'arn', file_no: tripAirArnIndex })
            )
          }
        }

        if (tripSea?.files?.arn) {
          const tripSeaArnIndex = tripSea.files.arn.findIndex(
            arnFile =>
              arnFile?.id === fileId || arnFile?.file_obj?.id === fileId
          )
          if (tripSeaArnIndex !== -1) {
            dispatch(
              removeFileTripSea({ file_type: 'arn', file_no: tripSeaArnIndex })
            )
          }
        }

        if (type === 'non') {
          dispatch(deleteArnFile({ id: fileId }))
        } else if (type === 'delete') {
          dispatch(deleteArnImage({ id: fileId }))
        }

        if (fileWithImage?.file_obj?.id || fileWithImage?.id) {
          dispatch(
            setFilterFiles({
              file: {
                file_no: customer_files?.files?.length,
                file: {},
                id: generateUUID(),
                fileName: fileWithImage?.file_obj?.file_name || '',
                status: 'File uploaded successfully.',
                progress: 100,
                isUploaded: true,
                isError: false,
                file_obj: fileWithImage?.file_obj || fileWithImage
              }
            })
          )
        }
      } catch (error) {
        console.error('Error deleting ARN file:', error)
      } finally {
        setDeleteLoader({ loading: false, id: '' })
      }
    }
  }

  const handleDeleteGbApplicationFileLocal = async (item, type) => {
    const tripId = tripAir?.attributes?.id || tripSea?.id
    const hasFiles = item?.files && item.files.length > 0
    const hasImage =
      hasFiles && item.files.some(file => file?.file_obj?.id || file?.id)

    if (hasImage) {
      const fileWithImage = item.files.find(
        file => file?.file_obj?.id || file?.id
      )

      const fileId = fileWithImage?.file_obj?.id || fileWithImage?.id
      setDeleteLoader({ loading: true, id: fileId })
      try {
        await handleDeleteTripDocument(tripId, fileId)
        await api.patch('/Api/V8/module', {
          data: {
            id: fileId,
            type: 'Documents',
            attributes: {
              gb_doc_type_c: ''
            }
          }
        })

        const itemIndex = gbApplicationFiles?.findIndex(doc => doc === item)
        if (itemIndex !== -1) {
          dispatch(removeGbApplicationDocFile({ no: itemIndex }))
        }

        if (tripAir?.files?.giveback_application) {
          const tripAirIndex = tripAir.files.giveback_application.findIndex(
            gbFile =>
              gbFile?.id === fileId || gbFile?.file_obj?.id === fileId
          )
          if (tripAirIndex !== -1) {
            dispatch(
              removeTripFile({
                file_type: 'giveback_application',
                file_no: tripAirIndex
              })
            )
          }
        }

        if (tripSea?.files?.giveback_application) {
          const tripSeaIndex = tripSea.files.giveback_application.findIndex(
            gbFile =>
              gbFile?.id === fileId || gbFile?.file_obj?.id === fileId
          )
          if (tripSeaIndex !== -1) {
            dispatch(
              removeFileTripSea({
                file_type: 'giveback_application',
                file_no: tripSeaIndex
              })
            )
          }
        }

        if (type === 'non') {
          dispatch(deleteGbApplicationFile({ id: fileId }))
        } else if (type === 'delete') {
          dispatch(deleteGbApplicationImage({ id: fileId }))
        }

        if (fileWithImage?.file_obj?.id || fileWithImage?.id) {
          dispatch(
            setFilterFiles({
              file: {
                file_no: customer_files?.files?.length,
                file: {},
                id: generateUUID(),
                fileName: fileWithImage?.file_obj?.file_name || '',
                status: 'File uploaded successfully.',
                progress: 100,
                isUploaded: true,
                isError: false,
                file_obj: fileWithImage?.file_obj || fileWithImage
              }
            })
          )
        }
      } catch (error) {
        console.error('Error deleting GB Application file:', error)
      } finally {
        setDeleteLoader({ loading: false, id: '' })
      }
    }
  }

  const handleUpdate = async (item, type) => {
    let update_id = ''
    update_id =
      item?.file?.file_obj?.id ||
      item?.file?.file_obj?.document_revision_id ||
      item?.file?.id ||
      ''

    const data = {
      id: update_id,
      type: 'Documents',
      attributes: {
        gb_doc_type_c: type === 'update' ? 'misc' : ''
      }
    }

    await handleUpdateMiscDocument(data)
  }

  const dropArnFile = async (item, index) => {
    const currentArnDoc = arnFiles?.[index]
    const checkData = currentArnDoc?.files?.length > 0 || false

    if (!checkData) {
      const agentId = getUserId() || ''
      await logApiActivity({
        contactId: contactId,
        agentId,
        apiEndpoint: '/Api/V8/custom/savedata/save-trip-data',
        actionType: 'drag_drop_arn_file',
        requestPayload: {
          contact_id: contactId,
          arn_index: index,
          gb_doc_type: ARN_DOC_TYPE,
          file_id: item?.file_obj?.id || item?.id
        },
        apiCall: async () => {
          const { id } = item?.file_obj || item || {}
          dispatch(removeUploadedDoc({ id }))
          dispatch(
            setArnDocFileWithData({
              no: index,
              file: {
                file_obj: {
                  ...(item?.file_obj || item),
                  gb_doc_type: ARN_DOC_TYPE
                },
                gb_doc_type: ARN_DOC_TYPE,
                new_relation_addition: true
              }
            })
          )
          await saveTripWithArnFile(item)
        }
      })
    }
  }

  const dropGbApplicationFile = async (item, index) => {
    const currentDoc = gbApplicationFiles?.[index]
    const hasFiles = currentDoc?.files?.length > 0 || false

    if (!hasFiles) {
      const { id } = item?.file_obj || item
      dispatch(removeUploadedDoc({ id }))
      dispatch(
        setGbApplicationDocFileWithData({
          no: index,
          file: {
            file_obj: item?.file_obj || item,
            new_relation_addition: true
          }
        })
      )

      await saveTripWithGbApplicationFile(item)
    }
  }

  const dropMiscDocument = async (item, index) => {
    const currentMiscDoc = misc_documents?.[index]
    const hasFiles = currentMiscDoc?.files && currentMiscDoc.files.length > 0

    if (!hasFiles) {
      const agentId = getUserId() || ''
      await logApiActivity({
        contactId: contactId,
        agentId,
        apiEndpoint: '/Api/V8/module',
        actionType: 'drag_drop_misc_document',
        requestPayload: {
          contact_id: contactId,
          misc_index: index,
          file_id: item?.file_obj?.id || item?.id
        },
        apiCall: async () => {
          const { id } = item?.file_obj || item
          dispatch(removeUploadedDoc({ id }))
          dispatch(
            setMiscDocFileWithData({
              no: index,
              file: {
                file_obj: item?.file_obj || item,
                new_relation_addition: true
              }
            })
          )
          await handleUpdate(
            { file: { ...(item?.file_obj || item) } },
            'update'
          )
        }
      })
    }
  }

  const dropItinerary = async id => {
    const agentId = getUserId() || ''
    await logApiActivity({
      contactId: contactId,
      agentId,
      apiEndpoint: '/Api/V8/custom/savedata/save-trip-data',
      actionType: 'drag_drop_itinerary',
      requestPayload: {
        contact_id: contactId,
        file_type: 'itinerary',
        file_id: id?.file_obj?.id || id?.id
      },
      apiCall: async () => {
        dispatch(
          addTripAirFileWithData({
            file_type: 'itinerary',
            file: { ...id, new_relation_addition: true }
          })
        )
        dispatch(removeUploadedDoc({ id: id?.file_obj?.id }))
        await saveTripWithAdditionalFile('itinerary', id)
      }
    })
  }

  const saveTripWithAdditionalFile = async (fileType, additionalFile) => {
    if (activeTripType === 'air') {
      await saveAirTripWithAdditionalFile(fileType, additionalFile)
    } else if (activeTripType === 'sea') {
      await saveSeaTripWithAdditionalFile(fileType, additionalFile)
    }
  }

  const saveAirTripWithAdditionalFile = async (fileType, additionalFile) => {
    var attributes = Object.assign({}, tripAir.attributes)
    attributes.date_of_visit = getFormatedDateForCRM(attributes.date_of_visit)
    attributes.boarding_date_of_departure = getFormatedDateForCRM(
      attributes.boarding_date_of_departure
    )

    delete attributes.ocr
    delete attributes.verify
    delete attributes.itinerary_clicked
    delete attributes?.arn_clicked

    // Process existing files from Redux state
    const existingFiles = processFilesWithTypes({
      entry_stamp: tripAir.files.entry_stamp,
      boarding_pass: tripAir.files.boarding_pass,
      itinerary: tripAir.files.itinerary,
      arn: tripAir.files.arn
    })

    // Process additional file
    const additionalFileId = extractFileId(additionalFile)

    // Create files_arr with proper structure
    const files_arr = {}
    let counter = 0

    // Add existing files
    Object.values(existingFiles).forEach(fileObj => {
      files_arr[counter] = fileObj
      counter++
    })

    // Add additional file
    if (additionalFileId) {
      files_arr[counter] = { [fileType]: additionalFileId }
    }

    var trip_id = ''
    if (tripAir.attributes.id) {
      trip_id = tripAir.attributes.id
    } else if (tripSea.id) {
      trip_id = tripSea.id
    }

    var apiCallData = {
      air_sea_type: 'air',
      date_of_visit: attributes.date_of_visit,
      entry_stamp: attributes.entry_stamp,
      boarding_verified: attributes.boarding_verified,
      send_secure_link: attributes.send_secure_link,
      boarding_first_name: attributes.boarding_first_name,
      boarding_last_name: attributes.boarding_last_name,
      boarding_airline_name: attributes.boarding_airline_name,
      boarding_flight_number: attributes.boarding_flight_number,
      boarding_exit_point: attributes.boarding_exit_point,
      boarding_date_of_departure: attributes.boarding_date_of_departure,
      id: trip_id
    }
    dispatch(setApiCall({ api_type: 'tripAir_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: apiCallData,
      ocr: tripAir.attributes.ocr,
      verification: tripAir.attributes.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripAir_saving' }))
  }

  const saveSeaTripWithAdditionalFile = async (fileType, additionalFile) => {
    var data = Object.assign({}, tripSea)
    data.date_of_visit = getFormatedDateForCRM(data.date_of_visit)
    delete data.files
    delete data.ocr
    delete data.verify

    // Process existing files from Redux state
    const existingFiles = processFilesWithTypes({
      cruise: tripSea.files.cruise,
      cruise_schedule: tripSea.files.cruise_schedule,
      itinerary: tripSea.files.itinerary,
      arn: tripSea.files.arn
    })

    // Process additional file
    const additionalFileId = extractFileId(additionalFile)

    // Create files_arr with proper structure
    const files_arr = {}
    let counter = 0

    // Add existing files
    Object.values(existingFiles).forEach(fileObj => {
      files_arr[counter] = fileObj
      counter++
    })

    // Add additional file
    if (additionalFileId) {
      files_arr[counter] = { [fileType]: additionalFileId }
    }

    data.air_sea_type = 'sea'
    if (tripAir.attributes.id) {
      data.id = tripAir.attributes.id
    } else if (tripSea.id) {
      data.id = tripSea.id
    }
    dispatch(setApiCall({ api_type: 'tripSea_saving', call: true }))

    const Result = await handleSaveTripData({
      basic: { ...data },
      ocr: tripSea.ocr,
      verification: tripSea.verify,
      contact_id: contactId,
      files: files_arr
    })

    dispatch(removeApiCall({ api_type: 'tripSea_saving' }))
  }
  const handleDeletePassportDocument = async (index, file) => {
    const id = extractFileId(file)
    let passportId = passport?.id
    await handleDeletePassport(passportId, id)
    dispatch(removeUploadedDoc({ id: id }))
    // Find the index of this file in passport.files array
    const fileIndex = passport.files.findIndex(
      f =>
        f?.file_obj?.id === file?.file_obj?.id ||
        f?.file_obj?.document_id === file?.file_obj?.document_id ||
        f?.id === file?.id ||
        f?.file_obj?.id === file?.id ||
        f?.file_obj?.document_id === file?.id
    )
    if (fileIndex !== -1) {
      dispatch(removePassportFile({ file_no: fileIndex }))
    }
    dispatch(
      setFilterFiles({
        file: {
          file_no: customer_files?.files.length,
          file: {},
          id: generateUUID(),
          fileName: file?.file_obj?.name || file?.name,
          status: 'File uploaded successfully.',
          progress: 100,
          isUploaded: true,
          isError: false,
          file_obj: file?.file_obj || file
        }
      })
    )
  }

  const handleDeleteBoardingDocument = async (index, file) => {
    const id = extractFileId(file)
    if (id) {
      await handleDeleteBoarding(tripAir?.attributes?.id, id)
    }
    // Find the index of this file in boarding_pass array
    const fileIndex = tripAir.files.boarding_pass.findIndex(
      f =>
        f?.file_obj?.id === file?.file_obj?.id ||
        f?.file_obj?.document_id === file?.file_obj?.document_id ||
        f?.id === file?.id ||
        f?.file_obj?.id === file?.id ||
        f?.file_obj?.document_id === file?.id
    )
    if (fileIndex !== -1) {
      dispatch(
        removeTripFile({ file_type: 'boarding_pass', file_no: fileIndex })
      )
      dispatch(
        setFilterFiles({
          file: {
            file_no: customer_files?.files.length,
            file: {},
            id: generateUUID(),
            fileName: file?.file_obj?.name || file?.name,
            status: 'File uploaded successfully.',
            progress: 100,
            isUploaded: true,
            isError: false,
            file_obj: file?.file_obj || file
          }
        })
      )
    }
  }

  const handleDeleteEntryStampDocument = async (index, file) => {
    const id = extractFileId(file)
    if (id) {
      await handleDeleteEntryStamp(tripAir?.attributes?.id, id)
    }
    // Find the index of this file in entry_stamp array
    const fileIndex = tripAir.files.entry_stamp.findIndex(
      f =>
        f?.file_obj?.id === file?.file_obj?.id ||
        f?.file_obj?.document_id === file?.file_obj?.document_id ||
        f?.id === file?.id ||
        f?.file_obj?.id === file?.id ||
        f?.file_obj?.document_id === file?.id
    )
    if (fileIndex !== -1) {
      dispatch(removeTripFile({ file_type: 'entry_stamp', file_no: fileIndex }))
      dispatch(
        setFilterFiles({
          file: {
            file_no: customer_files?.files.length,
            file: {},
            id: generateUUID(),
            fileName: file?.file_obj?.name || file?.name,
            status: 'File uploaded successfully.',
            progress: 100,
            isUploaded: true,
            isError: false,
            file_obj: file?.file_obj || file
          }
        })
      )
    }
  }

  const handleDeleteCruiseInfoDocument = async (index, file) => {
    const id = extractFileId(file)
    if (id) {
      await handleDeleteCruiseInfo(tripSea?.id, id)
    }
    // Find the index of this file in cruise array
    const fileIndex = tripSea.files.cruise.findIndex(
      f =>
        f?.file_obj?.id === file?.file_obj?.id ||
        f?.file_obj?.document_id === file?.file_obj?.document_id ||
        f?.id === file?.id ||
        f?.file_obj?.id === file?.id ||
        f?.file_obj?.document_id === file?.id
    )
    if (fileIndex !== -1) {
      dispatch(removeFileTripSea({ file_type: 'cruise', file_no: fileIndex }))
      // Avoid duplicating the file in Documents Library
      const restoredFileId =
        file?.file_obj?.id || file?.file_obj?.document_revision_id || file?.id
      const alreadyInLibrary = customer_files?.files?.some(f => {
        const libId =
          f?.file_obj?.id || f?.file_obj?.document_revision_id || f?.id
        return libId && restoredFileId && libId === restoredFileId
      })
      if (!alreadyInLibrary) {
        dispatch(
          setFilterFiles({
            file: {
              file_no: customer_files?.files.length,
              file: {},
              id: generateUUID(),
              fileName: file?.file_obj?.name || file?.name,
              status: 'File uploaded successfully.',
              progress: 100,
              isUploaded: true,
              isError: false,
              file_obj: file?.file_obj || file
            }
          })
        )
      }
    }
  }

  const handleDeleteCruiseScheduleDocument = async (index, file) => {
    const id = extractFileId(file)
    if (id) {
      await handleDeleteCruiseSchedule(tripSea?.id, id)
    }
    // Find the index of this file in cruise_schedule array
    const fileIndex = tripSea.files.cruise_schedule.findIndex(
      f =>
        f?.file_obj?.id === file?.file_obj?.id ||
        f?.file_obj?.document_id === file?.file_obj?.document_id ||
        f?.id === file?.id ||
        f?.file_obj?.id === file?.id ||
        f?.file_obj?.document_id === file?.id
    )
    if (fileIndex !== -1) {
      dispatch(
        removeFileTripSea({ file_type: 'cruise_schedule', file_no: fileIndex })
      )
      // Avoid duplicating the file in Documents Library
      const restoredFileId =
        file?.file_obj?.id || file?.file_obj?.document_revision_id || file?.id
      const alreadyInLibrary = customer_files?.files?.some(f => {
        const libId =
          f?.file_obj?.id || f?.file_obj?.document_revision_id || f?.id
        return libId && restoredFileId && libId === restoredFileId
      })
      if (!alreadyInLibrary) {
        dispatch(
          setFilterFiles({
            file: {
              file_no: customer_files?.files.length,
              file: {},
              id: generateUUID(),
              fileName: file?.file_obj?.name || file?.name,
              status: 'File uploaded successfully.',
              progress: 100,
              isUploaded: true,
              isError: false,
              file_obj: file?.file_obj || file
            }
          })
        )
      }
    }
  }

  const handleDeleteItineraryDocument = async (index, file) => {
    const id = extractFileId(file)
    if (id) {
      await handleDeleteItinerary(tripAir?.attributes?.id, id)
    }
    // Find the index of this file in itinerary array
    const fileIndex = tripAir.files.itinerary.findIndex(
      f =>
        f?.file_obj?.id === file?.file_obj?.id ||
        f?.file_obj?.document_id === file?.file_obj?.document_id ||
        f?.id === file?.id ||
        f?.file_obj?.id === file?.id ||
        f?.file_obj?.document_id === file?.id
    )
    if (fileIndex !== -1) {
      dispatch(removeTripFile({ file_type: 'itinerary', file_no: fileIndex }))
      dispatch(
        setFilterFiles({
          file: {
            file_no: customer_files?.files.length,
            file: {},
            id: generateUUID(),
            fileName: file?.file_obj?.name || file?.name,
            status: 'File uploaded successfully.',
            progress: 100,
            isUploaded: true,
            isError: false,
            file_obj: file?.file_obj || file
          }
        })
      )
    }
  }


  const handleDeleteCreditCardDocument = async (cardIndex, fileIndex, file) => {
    const card = purchase_cards?.[cardIndex]
    if (!card) return

    const docId = extractFileId(file)
    if (!card?.attributes?.id || !docId) return

    try {
      const response = await handleRemoveCreditCardDoc(
        card.attributes.id,
        docId
      )
      if (!response) return

      // Remove the exact file index provided by UI
      if (typeof fileIndex === 'number' && fileIndex > -1) {
        dispatch(removePaymentCardFile({ no: cardIndex, file_no: fileIndex }))
      }

      // Restore the file back to Documents Library ONLY if it doesn't already exist there
      const restoredFileId =
        file?.file_obj?.id ||
        file?.file_obj?.document_revision_id ||
        file?.id ||
        file?.file_obj?.id

      const alreadyInLibrary = customer_files?.files?.some(f => {
        const libId =
          f?.file_obj?.id ||
          f?.file_obj?.document_revision_id ||
          f?.id ||
          f?.file_obj?.id
        return libId && restoredFileId && libId === restoredFileId
      })

      if (!alreadyInLibrary) {
        const sourceFileObj = file?.file_obj || file || {}
        const sanitizedFileObj = {
          ...sourceFileObj,
          gb_doc_type: null,
          new_relation_addition: false
        }
        dispatch(
          setFilterFiles({
            file: {
              file_no: customer_files?.files.length,
              file: {},
              id: generateUUID(),
              fileName: file?.file_obj?.name || file?.name,
              status: 'File uploaded successfully.',
              progress: 100,
              isUploaded: true,
              isError: false,
              file_obj: sanitizedFileObj
            }
          })
        )
      }
      if (restoredFileId) {
        dispatch(sanitizeLibraryFileById({ fileId: restoredFileId }))
      }

      dispatch(incrementImageRefreshCounter())

      if (card?.attributes?.ocr_status === '1') {
        const resetResponse = await handleResetCreditCardFields(
          card.attributes.id,
          docId
        )
        dispatch(resetPaymentCardFields({ no: cardIndex }))
        const preDeleteFiles = card?.files || []
        const remainingFileCount =
          typeof fileIndex === 'number' && fileIndex > -1
            ? Math.max(preDeleteFiles.length - 1, 0)
            : preDeleteFiles.length
        if (remainingFileCount > 0) {
          dispatch(markPaymentCardFilesAsNewRelation({ no: cardIndex }))
        }

        if (resetResponse?.success && resetResponse?.restored_status) {
          const otherCards = (purchase_cards || []).filter(
            (c, idx) => idx !== cardIndex && c?.files?.length > 0
          )
          const allOtherCardsPass = otherCards.every(c => {
            const a = c?.attributes || {}
            return (
              a.luhn_check === '1' &&
              a.bin_check === '1' &&
              a.redaction_verified === '1' &&
              a.ocr_status === '1'
            )
          })

          if (!allOtherCardsPass) {
            return
          }

          const restoredStatus = resetResponse.restored_status
          const previousStatusBeforeReset = customer?.status_c
          const previousStatusBeforeResetSnapshot = customer?.previous_status_c
          const normalizedRestored = String(restoredStatus)
            .trim()
            .toLowerCase()
          const isRestoredAuthAccess =
            normalizedRestored === 'auth access' ||
            normalizedRestored === 'auth_access'

          dispatch(
            updateCustomerField({
              field: 'status_c',
              value: restoredStatus
            })
          )
          dispatch(
            updateCustomerField({
              field: 'previous_status_c',
              value: previousStatusBeforeReset
            })
          )

          const agentId = getUserId() || ''
          const payload = {
            contact_id: customer?.id,
            agent_id: agentId,
            status_c: restoredStatus,
            previous_status_c: previousStatusBeforeReset,
            is_locked_c: isRestoredAuthAccess ? 1 : 0,
            method: "auto",
          }

          try {
            const statusResponse = await handleSetStatusChange(payload)
            const isStatusSuccess =
              statusResponse?.data?.success === true ||
              statusResponse?.success === true ||
              !!statusResponse
            if (!isStatusSuccess) {
              dispatch(
                updateCustomerField({
                  field: 'status_c',
                  value: previousStatusBeforeReset
                })
              )
              dispatch(
                updateCustomerField({
                  field: 'previous_status_c',
                  value: previousStatusBeforeResetSnapshot
                })
              )
            }
          } catch (statusError) {
            console.error(
              'Error calling set-status-change after credit card reset:',
              statusError
            )
            dispatch(
              updateCustomerField({
                field: 'status_c',
                value: previousStatusBeforeReset
              })
            )
            dispatch(
              updateCustomerField({
                field: 'previous_status_c',
                value: previousStatusBeforeResetSnapshot
              })
            )
          }
        }
      }
    } catch (error) {
      console.error('Error deleting credit card document:', error)
    }
  }

  const handleDeleteCreditCard = async cardIndex => {
    const card = purchase_cards[cardIndex]

    if (card?.attributes?.id) {
      // Delete the entire credit card from the server
      try {
        const response = await DeleteCreditCard(card.attributes.id)

        if (response) {
          // Remove the card from local state
          dispatch(removePaymentCard({ no: cardIndex }))
          dispatch(
            removePaymentCardFile({ no: cardIndex, file_no: card.files.length })
          )
        }
      } catch (error) {
        console.error('Error deleting credit card:', error)
      }
    }
  }
  const handleDeleteMiscDocumentFile = async (index, file) => {
    if (index >= 0 && index < misc_documents.length) {
      const doc = misc_documents[index]
      await handleDeleteMiscDocument(doc, 'delete')
    }
  }

  const handleDeleteArnDocumentFile = async (index, file) => {
    if (index >= 0 && index < arnFiles.length) {
      const doc = arnFiles[index]
      await handleDeleteArnFileLocal(doc, 'delete')
    }
  }

  const handleDeleteGbApplicationDocumentFile = async (index, file) => {
    if (index >= 0 && index < gbApplicationFiles.length) {
      const doc = gbApplicationFiles[index]
      await handleDeleteGbApplicationFileLocal(doc, 'delete')
    }
  }

  return (
    <TravelDocumentsContainer>
      <TravelDocumentsRow>
        <DragAndDropCard
          label="Passport"
          text="PASSPORT"
          borderColor="lightYellow"
          align="center"
          files={passport?.files ?? []}
          haveOcr={passport?.ocr?.passport_number?.ocr !== 0}
          onDrop={id => dropPassport(id)}
          deleteHandler={handleDeletePassportDocument}
          isDeletable={false}
          allowMultiple={false}
          hasIconPurchase={false}
        >
          <DropCardText>Drop Image from top bar</DropCardText>
        </DragAndDropCard>
        {activeTripType === 'sea' ? (
          <>
            <DragAndDropCard
              label="Cruise info"
              text="CRUISE INFO"
              borderColor="lightYellow"
              align="center"
              isDeletable={false}
              haveOcr={tripSea?.ocr?.cruise_name?.ocr !== 0}
              files={tripSea?.files?.cruise || []}
              deleteHandler={handleDeleteCruiseInfoDocument}
              onDrop={id => dropCruiseInfo(id)}
              hasIconPurchase={false}
            >
              <DropCardText>Drop Image from top bar</DropCardText>
            </DragAndDropCard>
            <DragAndDropCard
              label="Cruise Schedule"
              text="CRUISE SCHEDULE"
              borderColor="lightYellow"
              align="center"
              isDeletable={false}
              files={tripSea?.files?.cruise_schedule || []}
              deleteHandler={handleDeleteCruiseScheduleDocument}
              onDrop={id => dropCruiseSchedule(id)}
              allowMultiple={false}
              hasIconPurchase={false}
            >
              <DropCardText>Drop Image from top bar</DropCardText>
            </DragAndDropCard>
          </>
        ) : (
          <>
            <DragAndDropCard
              label="Boarding"
              text="BOARDING"
              borderColor="lightYellow"
              align="center"
              isDeletable={false}
              haveOcr={tripAir?.attributes?.ocr?.boarding_first_name?.ocr !== 0}
              files={tripAir?.files?.boarding_pass || []}
              deleteHandler={handleDeleteBoardingDocument}
              onDrop={id => dropBoarding(id)}
              allowMultiple={false}
              hasIconPurchase={false}
            >
              <DropCardText>Drop Image from top bar</DropCardText>
            </DragAndDropCard>
            <DragAndDropCard
              label="Entry Stamp"
              text="ENTRY STAMP"
              borderColor="lightYellow"
              align="center"
              isDeletable={false}
              haveOcr={false}
              files={tripAir?.files?.entry_stamp || []}
              deleteHandler={handleDeleteEntryStampDocument}
              onDrop={id => dropEntryStamp(id)}
              allowMultiple={false}
            >
              <DropCardText>Drop Image from top bar</DropCardText>
            </DragAndDropCard>
          </>
        )}

        {purchase_cards &&
          purchase_cards.length > 0 &&
          purchase_cards?.map((card, index) => {
            const cardFiles = purchase_cards?.[index]?.files || []

            const attrs = card?.attributes || {}
            const checksAllPassed =
              attrs.ocr_status === '1' &&
              attrs.luhn_check === '1' &&
              attrs.bin_check === '1' &&
              attrs.redaction_verified === '1'
            const shouldLockCard = !checksAllPassed

            return (
              <DragAndDropCard
                key={card?.attributes?.id || index}
                text={`CARD ${index + 1}`}
                borderColor="lightYellow"
                align="center"
                haveOcr={
                  (card?.ocr?.credit_card_number?.ocr ??
                    card?.ocr?.card_number?.ocr ??
                    0) === 1
                }
                files={cardFiles}
                label={`Card ${index + 1}`}
                deleteHandler={(fileIndex, file) =>
                  handleDeleteCreditCardDocument(index, fileIndex, file)
                }
                onDrop={id => dropCreditCard(id, index)}
                isDeletable={card?.attributes?.id && index > 0 ? true : false}
                onCardDelete={() => handleDeleteCreditCard(index)}
                allowMultiple={true}
                hasIconPurchase={false}
                cardId={shouldLockCard ? card?.attributes?.id || null : null}
                actualCardId={card?.attributes?.id || null}
              >
                <DropCardText>Drop Image from top bar</DropCardText>
              </DragAndDropCard>
            )
          })}
        {misc_documents &&
          misc_documents.length > 0 &&
          misc_documents.map((doc, index) => (
            <DragAndDropCard
              key={`misc-${index}`}
              text={`MISC ${index + 1}`.toUpperCase()}
              borderColor="lightYellow"
              align="center"
              deleteHandler={file => handleDeleteMiscDocumentFile(index, file)}
              onDrop={item => dropMiscDocument(item, index)}
              files={misc_documents?.[index]?.files || []}
              isDeletable={true}
              label={`MISC ${index + 1}`}
              onCardDelete={() => {
                // Remove the misc document card from UI
                dispatch(removeMiscDoc({ no: index }))
              }}
              allowMultiple={false}
              hasIconPurchase={false}
            >
              <DropCardText>Drop Image from top bar</DropCardText>
            </DragAndDropCard>
          ))}

        {arnFiles &&
          arnFiles.length > 0 &&
          arnFiles.map((doc, index) => {
            const slotFilled = isArnSlotFilled(doc)
            if (!isAmexRefund && doc?.amexAutoSlot && !slotFilled) {
              return null
            }

            return (
              <DragAndDropCard
                key={`arn-${index}`}
                text={`ARN ${index + 1}`.toUpperCase()}
                borderColor="lightYellow"
                align="center"
                isDeletable={true}
                files={arnFiles?.[index]?.files || []}
                label={`ARN ${index + 1}`}
                onDrop={item => dropArnFile(item, index)}
                deleteHandler={file => handleDeleteArnDocumentFile(index, file)}
                onCardDelete={() => {
                  const arnDoc = arnFiles[index]
                  if (arnDoc?.id) {
                    dispatch(deleteArnImage({ id: arnDoc.id }))
                  } else {
                    dispatch(deleteArnByIndex({ index }))
                  }
                }}
                allowMultiple={false}
                hasIconPurchase={false}
                enableImagePaste={!slotFilled}
                onPasteImage={event =>
                  handleCardPaste(
                    event,
                    uploaded => dropArnFile(uploaded, index),
                    index
                  )
                }
              >
                <DropCardText>
                  {isPasting
                    ? 'Uploading pasted image...'
                    : 'Drop Image from top bar, or paste'}
                </DropCardText>
              </DragAndDropCard>
            )
          })}

        {gbApplicationFiles &&
          gbApplicationFiles.length > 0 &&
          gbApplicationFiles?.map((doc, index) => {
            const gbApplicationLabel =
              gbApplicationFiles.length <= 1 || index === 0
                ? 'GB Application'
                : `GB Application ${index + 1}`
            const gbApplicationText =
              gbApplicationFiles.length <= 1 || index === 0
                ? 'GB APPLICATION'
                : `GB APPLICATION ${index + 1}`

            return (
              <DragAndDropCard
                key={`gbapp-${index}`}
                text={gbApplicationText}
                borderColor="lightYellow"
                align="center"
                isDeletable={true}
                files={gbApplicationFiles?.[index]?.files || []}
                label={gbApplicationLabel}
                onDrop={item => dropGbApplicationFile(item, index)}
                deleteHandler={file =>
                  handleDeleteGbApplicationDocumentFile(index, file)
                }
                onCardDelete={() => {
                  const gbDoc = gbApplicationFiles[index]
                  if (gbDoc?.id) {
                    dispatch(deleteGbApplicationImage({ id: gbDoc.id }))
                  } else {
                    dispatch(deleteGbApplicationByIndex({ index }))
                  }
                }}
                allowMultiple={false}
                hasIconPurchase={false}
              >
                <DropCardText>Drop Image from top bar</DropCardText>
              </DragAndDropCard>
            )
          })}

        {tripAir?.files?.itinerary?.length > 0 ||
          tripAir?.attributes?.itinerary_clicked ? (
          <DragAndDropCard
            text="ITINERARY"
            borderColor="lightYellow"
            align="center"
            haveOcr={false}
            files={tripAir?.files?.itinerary || []}
            label="Itinerary"
            deleteHandler={handleDeleteItineraryDocument}
            onDrop={id => dropItinerary(id)}
            isDeletable={true}
            onCardDelete={() => {
              dispatch(
                setTripAir({
                  itinerary_clicked: false
                })
              )
            }}
            allowMultiple={false}
            hasIconPurchase={false}
          >
            <DropCardText>Drop Image from top bar</DropCardText>
          </DragAndDropCard>
        ) : null}
      </TravelDocumentsRow>
      <TravelDocumentsButtonsRow>
        <AddButton
          text="+ Add another card"
          onClick={handleAddCard}
          disabled={loadingStates.addCard}
          loading={loadingStates.addCard}
          font_size="13.28px"
        />

        {activeTripType === 'air' && (
          <AddButton
            text="+ Itinerary"
            onClick={handleAddItinerary}
            disabled={loadingStates.itinerary}
            loading={loadingStates.itinerary}
            font_size="13.28px"
          />
        )}

        <AddButton
          text="+MISC"
          onClick={handleAddMisc}
          disabled={loadingStates.misc}
          loading={loadingStates.misc}
          font_size="13.28px"
        />
        <AddButton
          text="+ARN"
          onClick={handleAddArn}
          disabled={loadingStates.arn}
          loading={loadingStates.arn}
          font_size="13.28px"
        />
        <AddButton
          text="+ GB Application"
          onClick={handleAddGbApplication}
          disabled={loadingStates.gbApplication}
          loading={loadingStates.gbApplication}
          font_size="13.28px"
        />
      </TravelDocumentsButtonsRow>
      {duplicateImagesModal && (
        <DuplicateImagesModal
          open={duplicateImagesModal}
          onClose={closeDuplicateModal}
          duplicateImagesFiles={duplicateImagesFiles}
        />
      )}
      {disallowedImagesModal && (
        <DisAllowedImagesModal
          open={disallowedImagesModal}
          onClose={closeDisallowedModal}
          disAllowedFiles={disAllowedFiles}
        />
      )}
    </TravelDocumentsContainer>
  )
}

const TravelDocumentsContainer = styled.div`
  margin-top: 20px;
`

const TravelDocumentsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1.3rem;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const DropCardText = styled.p`
  font-size: 12px;
  text-align: center;
  margin-top: 30%;
  color: #777;
`
const TravelDocumentsButtonsRow = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 10px;
`

export default TravelDocuments
